import { render, staticRenderFns } from "./testing-prop-code-snippet.vue?vue&type=template&id=7eb7dac6&scoped=true&lang=html"
import script from "./testing-prop-code-snippet.vue?vue&type=script&lang=js"
export * from "./testing-prop-code-snippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb7dac6",
  null
  
)

/* custom blocks */
import block0 from "./testing-prop-code-snippet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports